var map = {
	"./bounce/blocks": 2155,
	"./calc/blocks": 2156,
	"./craft/agent/blocks": 2158,
	"./craft/code-connection/blocks": 2159,
	"./craft/designer/blocks": 2014,
	"./craft/simple/blocks": 2157,
	"./dance/blocks": 1589,
	"./eval/blocks": 2160,
	"./flappy/blocks": 2161,
	"./jigsaw/blocks": 2167,
	"./maze/blocks": 2168,
	"./p5lab/spritelab/blocks": 1340,
	"./sites/studio/pages/blocks": 2181,
	"./studio/blocks": 2022,
	"./turtle/blocks": 2176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2569;